<!-- eslint-disable vue/no-v-model-argument -->
<template>
  <div>
    <div v-if="isDev">
      <!-- addTreeData: <pre style="font-size: 10px; max-height: 200px; overflow-y: auto;">{{JSON.stringify(addTreeData, null, 2)}}</pre> -->
      <!-- docSectionsData: <pre style="font-size: 10px; max-height: 200px; overflow-y: auto;">{{ JSON.stringify(docSectionsData, null, 2) }}</pre> -->
      <!-- removeTreeData: <pre style="font-size: 10px; max-height: 200px; overflow-y: auto;">{{JSON.stringify(removeTreeData, null, 2)}}</pre> -->
    </div>

    <AntFormItem
      name="title"
      v-bind="validateInfos.docTitle"
    >
      <template #label>
        <div class="form-item-label">
          Title
          <AntTooltip
            title="此標題將顯示於「瀏覽器頁籤」及「API 文件頂端」"
            placement="rightTop"
          >
            <QuestionIcon class="question-icon" />
          </AntTooltip>
        </div>
      </template>

      <AntInput :value="docTitle" disabled />
    </AntFormItem>

    <AntFormItem name="subName">
      <template #label>
        <div class="form-item-label">
        Sub Name
        <AntTooltip
          title="Title 中括號內的文字，通常用於標示特殊客戶或環境，非必填"
          placement="rightTop"
        >
          <QuestionIcon class="question-icon" />
        </AntTooltip>
        </div>
      </template>

      <AntInput
        :value="selectedSectionState.subName"
        @change="onChange('subName', $event.target.value); onChange('docTitle', docTitle)"
      />
    </AntFormItem>

    <AntRow
      v-if="selectedSectionState.route"
      :gutter="16"
    >
      <AntCol
        :span="12"
        class="tree"
      >
        <AntFormItem
          name="route"
          label="Route"
          :labelCol="{ span: 6 }"
          :wrapperCol="{ span: 18 }"
        >
          <div style="display: flex; align-items: center;">
            <div style="white-space: nowrap; margin-right: 4px;">
              {{ `${selectedSectionState.domain}/api-doc/${selectedSectionState.wallet}-wallet/` }}
            </div>
            <AntInput
              :value="selectedSectionState.route"
              disabled
            />
          </div>
        </AntFormItem>
      </AntCol>
      <AntCol
        :span="12"
        class="tree"
      >
        <AntFormItem
          name="template"
          label="Template"
          :labelCol="{ span: 4 }"
          :wrapperCol="{ span: 20 }"
        >
          <AntSelect
            :value="selectedSectionState.templateId"
            :options="templateOptions"
            disabled
          />
        </AntFormItem>
      </AntCol>
    </AntRow>

    <AntFormItem name="currency">
      <template #label>
        <div class="form-item-label">
          Currency
          <AntTooltip
            title="API 文件內 {{currency}} 替代字樣，通常用於 API 區塊的 currency 參數範例"
            placement="rightTop"
          >
            <QuestionIcon class="question-icon" />
          </AntTooltip>
        </div>
      </template>

      <AntInput
        :value="selectedSectionState.currency"
        @change="onChange('currency', $event.target.value)"
      />
    </AntFormItem>

    <AntFormItem name="platforms">
      <template #label>
        <div class="form-item-label">
          Platforms
          <AntTooltip
            title="選擇「All」，下方會顯示 Excluded Platforms 欄位，可選擇欲排除的平台"
            placement="rightTop"
          >
            <QuestionIcon class="question-icon" />
          </AntTooltip>
        </div>
      </template>

      <PlatformDocSelect
        type="platforms"
        :value="selectedSectionState.platforms"
        :options="platformOptions"
        @change="val => onPlatformDocSelectChange('platforms', val)"
      />
    </AntFormItem>

    <AntFormItem
      v-if="!selectedSectionState.platforms || !selectedSectionState.platforms.length"
      name="excludedPlatforms"
      label="Excluded Platforms"
    >
      <PlatformDocSelect
        type="excludedPlatforms"
        :value="selectedSectionState.excludedPlatforms"
        :options="entirePlatformOptions"
        @change="val => onPlatformDocSelectChange('excludedPlatforms', val)"
      />
    </AntFormItem>

    <AntFormItem name="ipWhiteList">
      <template #label>
        <div class="form-item-label">
          IP White List
          <span @click.prevent.stop>
            <AntTooltip placement="rightTop">
              <template #title>
                <div>
                  設定可訪問此 API 文件的 IP 白名單。
                  <br/>
                  開啟狀態：僅 IP 白名單可訪問
                  <br/>
                  關閉狀態：所有 IP 皆可訪問
                </div>
              </template>
              <QuestionIcon class="question-icon" />
            </AntTooltip>
          </span>
        </div>
      </template>
      <div class="ip-whitelist-switch-row">
        <AntSwitch
          :checked="ipWhiteListEnabled"
          :loading="ipUpdating"
          :disabled="ipUpdating"
          @change="onIpWhiteListSwitch"
        />
        <AntButton
          v-if="ipWhiteListEnabled"
          style="padding: 0 4px;"
          type="link"
          @click="ipDrawerVisible = true"
        >
          View IP White List
        </AntButton>
        <AntAlert
          v-if="isIpWhiteListEmpty"
          type="error"
          :showIcon="false"
          message="白名單目前為空，將拒絕所有 IP 訪問。請點擊左側按鈕新增 IP 白名單，或關閉開關以不限制 IP 訪問 API 文件。"
          banner
        />
      </div>
    </AntFormItem>

    <AntDrawer
      title="IP White List"
      :width="800"
      :visible="ipDrawerVisible"
      @close="ipDrawerVisible = false"
    >
      <div class="ip-whitelist-table">
        <AntAlert
          v-if="isIpWhiteListEmpty"
          type="error"
          :showIcon="false"
          message="白名單目前為空，將拒絕所有 IP 訪問。請在下方新增 IP 白名單，或關閉 IP White List 開關以不限制 IP 訪問 API 文件。"
          style="margin-bottom: 16px;"
          banner
        />
        <div class="ip-whitelist-toolbar">
          <AntButton
            type="primary"
            :disabled="ipUpdating"
            @click="onAddAllowedIpRow"
          >
            <template #icon>
              <AddIcon />
            </template>
            Add
          </AntButton>
        </div>
        <AntTable
          size="small"
          :columns="ipWhiteListColumns"
          :dataSource="ipDataSource"
          :pagination="false"
          rowKey="key"
        >
          <template #bodyCell="{ text, column, record }">
            <template v-if="column.dataIndex === 'ip'">
              <div v-if="editableIpData[record.key]">
                <AntInput
                  v-model:value="editableIpData[record.key].ip"
                  placeholder="IP"
                  allowClear
                  :class="{ 'ip-input--error': !!getAllowedIpError(record.key, editableIpData[record.key].ip) }"
                />
                <div
                  v-if="getAllowedIpError(record.key, editableIpData[record.key].ip)"
                  class="ip-field-error"
                >
                  {{ getAllowedIpError(record.key, editableIpData[record.key].ip) }}
                </div>
              </div>
              <div v-else>{{ text }}</div>
            </template>
            <template v-else-if="column.dataIndex === 'remark'">
              <AntTextarea
                v-if="editableIpData[record.key]"
                v-model:value="editableIpData[record.key].remark"
                :rows="3"
                placeholder="Remark"
                allowClear
              />
              <div
                v-else
                style="max-height: 60px; overflow-y: auto;"
                v-html="(text || '').replaceAll('\n', '<br/>')"
              />
            </template>
            <template v-else-if="column.dataIndex === 'action'">
              <div class="action-icons">
                <span v-if="editableIpData[record.key]">
                  <span
                    v-if="editableIpData[record.key].ip"
                    :class="{ 'action-icon--disabled': !!getAllowedIpError(record.key, editableIpData[record.key].ip) }"
                    :title="getAllowedIpError(record.key, editableIpData[record.key].ip) || 'Save'"
                    @click="!getAllowedIpError(record.key, editableIpData[record.key].ip) && onSaveAllowedIpRow(record)"
                  >
                    <SaveIcon />
                  </span>
                  <CancelIcon
                    title="Cancel"
                    @click="onCancelAllowedIpRow(record)"
                  />
                </span>
                <span v-else>
                  <EditIcon
                    title="Edit"
                    @click="onEditAllowedIpRow(record.key)"
                  />
                  <AntPopconfirm
                    :title="ipDataSource.length <= 1
                      ? `刪除後白名單將為空，所有 IP 皆無法訪問。確定刪除 ${record.ip}？`
                      : `Sure to delete ${record.ip}?`"
                    @confirm="onDeleteAllowedIpRow(record)"
                  >
                    <DeleteIcon title="Delete" />
                  </AntPopconfirm>
                </span>
              </div>
            </template>
          </template>
        </AntTable>
      </div>
    </AntDrawer>

    <AntAlert
      v-if="!!shouldBeAddedLinkSections.length"
      class="section-alert"
      type="warning"
      showIcon
    >
      <template #message>
        此子本中有使用到以下 Section 的超連結，請將連結移除，或是至以下 Section 的 Used In 欄位<span style="color: #f50;">加入</span>此子本 <b>{{ selectedSectionState.docShortTitle }}</b>：
        <div class="section-suggest-tree">
          <AntTree
            :key="selectedSectionState.docId"
            :treeData="shouldBeAddedLinkTreeData"
            :fieldNames="{ key: 'treeKey', title: 'treeTitleWithRemark', children: 'treeChildren' }"
            :selectable="false"
            defaultExpandAll
          >
            <template #title="{ dataRef, treeTitleWithRemark }">
              <AntTooltip
                v-if="dataRef && !dataRef.isLinkable"
                title="此區塊已加入"
                placement="right"
              >
                <span class="section-suggest-tree-title section-suggest-tree-title--added">
                  <span v-if="isDev && dataRef?.sectionId" style="color: BurlyWood;">{{ dataRef.sectionId }} </span>
                  <span>{{ treeTitleWithRemark }}</span>
                </span>
              </AntTooltip>
              <span
                v-else
                class="section-suggest-tree-title"
              >
                <span v-if="isDev && dataRef?.sectionId" style="color: BurlyWood;">{{ dataRef.sectionId }} </span>
                <span>{{ treeTitleWithRemark }}</span>
                <AntPopover
                  v-if="dataRef?.linkUsedSections?.length"
                  :title="`使用到「${dataRef.enTitle} ${dataRef.cnTitle}${dataRef.remark ? ` ${dataRef.remark}` : ''}」連結的區塊：`"
                  placement="right"
                >
                  <QuestionIcon class="hint-icon" />
                  <template #content>
                    <ul class="section-list" style="max-height: 300px; overflow-y: auto;">
                      <li
                        v-for="linkUsedSection in dataRef.linkUsedSections"
                        :key="linkUsedSection.sectionId"
                      >
                        <span v-if="isDev" style="color:BurlyWood;">{{ linkUsedSection.sectionId }} </span>
                        {{ linkUsedSection.enTitle }} {{ linkUsedSection.cnTitle }} {{ linkUsedSection.remark }}
                      </li>
                    </ul>
                  </template>
                </AntPopover>
                <SectionPlatformTags
                  :section="dataRef"
                  :platformsMap="entirePlatformsMap"
                />
                <span class="section-suggest-action">
                  <AntTooltip title="點擊加入" placement="right">
                    <AntPopconfirm
                      :title="`確認將 ${selectedSectionState.docShortTitle} 加入此區塊嗎？`"
                      @confirm="onAddDocToSection(dataRef?.sectionId)"
                    >
                      <AddIcon class="add-remove-icon" />
                    </AntPopconfirm>
                  </AntTooltip>
                </span>
              </span>
            </template>
          </AntTree>
        </div>
      </template>
    </AntAlert>

    <AntAlert
      v-if="!!shouldBeAddedSections.length"
      class="section-alert"
      type="warning"
      showIcon
    >
      <template #message>
        建議將以下 Section 的 Used In 欄位<span style="color: #f50;">加入</span>此子本 <b>{{ selectedSectionState.docShortTitle }}</b>：<br>
        只要 Section 符合此子本的 Platform 支援度，就會顯示在下方，請參考標題後的 Remark (如 xxx only) 再決定是否加入。
        <div class="section-suggest-tree">
          <AntTree
            :key="selectedSectionState.docId"
            :treeData="shouldBeAddedTreeData"
            :fieldNames="{ key: 'treeKey', title: 'treeTitleWithRemark', children: 'treeChildren' }"
            :selectable="false"
            defaultExpandAll
          >
            <template #title="{ dataRef, treeTitleWithRemark }">
              <AntTooltip
                v-if="dataRef && !dataRef.isLinkable"
                title="此區塊已加入"
                placement="right"
              >
                <span class="section-suggest-tree-title section-suggest-tree-title--added">
                  <span v-if="isDev && dataRef?.sectionId" style="color: BurlyWood;">{{ dataRef.sectionId }} </span>
                  <span>{{ treeTitleWithRemark }}</span>
                </span>
              </AntTooltip>
              <span
                v-else
                class="section-suggest-tree-title"
              >
                <span v-if="isDev && dataRef?.sectionId" style="color: BurlyWood;">{{ dataRef.sectionId }} </span>
                <span>{{ treeTitleWithRemark }}</span>
                <!-- <span
                  class="link"
                  @click="dataRef?.isLinkable && onTreeTitleClick(dataRef.sectionId)"
                >{{ treeTitleWithRemark }}</span> -->
                <SectionPlatformTags
                  :section="dataRef"
                  :platformsMap="entirePlatformsMap"
                />
                <span class="section-suggest-action">
                  <AntTooltip title="點擊加入" placement="right">
                    <AntPopconfirm
                      :title="`確認將 ${selectedSectionState.docShortTitle} 加入此區塊嗎？`"
                      @confirm="onAddDocToSection(dataRef?.sectionId)"
                    >
                      <AddIcon class="add-remove-icon" />
                    </AntPopconfirm>
                  </AntTooltip>
                </span>
              </span>
            </template>
          </AntTree>
        </div>
      </template>
    </AntAlert>

    <AntAlert
      v-if="!!shouldBeRemovedSections.length"
      class="section-alert"
      type="error"
      showIcon
    >
      <template #message>
        因為 Platform 設定不相符，建議將以下 Section 的 Used In 欄位<span style="color: #f50;">移除</span>此子本 <b>{{ selectedSectionState.docShortTitle }}</b>：
        <div class="section-suggest-tree">
          <AntTree
            :key="selectedSectionState.docId"
            :treeData="shouldBeRemovedTreeData"
            :fieldNames="{ key: 'treeKey', title: 'treeTitleWithRemark', children: 'treeChildren' }"
            :selectable="false"
            defaultExpandAll
          >
            <template #title="{ dataRef, treeTitleWithRemark }">
              <AntTooltip
                v-if="dataRef && !dataRef.isRemovable"
                title="此區塊不需移除"
                placement="right"
              >
                <span class="section-suggest-tree-title section-suggest-tree-title--added">
                  <span v-if="isDev && dataRef?.sectionId" style="color: BurlyWood;">{{ dataRef.sectionId }} </span>
                  <span>{{ treeTitleWithRemark }}</span>
                </span>
              </AntTooltip>
              <span
                v-else
                class="section-suggest-tree-title"
              >
                <span v-if="isDev && dataRef?.sectionId" style="color: BurlyWood;">{{ dataRef.sectionId }} </span>
                <span>{{ treeTitleWithRemark }}</span>
                <SectionPlatformTags
                  :section="dataRef"
                  :platformsMap="entirePlatformsMap"
                />
                <AntTooltip
                  v-if="sectionPlatformMismatchHint(dataRef)"
                  :title="sectionPlatformMismatchHint(dataRef)"
                  placement="top"
                >
                  <QuestionIcon class="hint-icon" />
                </AntTooltip>
                <span class="section-suggest-action">
                  <AntTooltip title="點擊移除" placement="right">
                    <AntPopconfirm
                      :title="`確認將 ${selectedSectionState.docShortTitle} 從此區塊移除嗎？`"
                      @confirm="onRemoveDocFromSection(dataRef?.sectionId)"
                    >
                      <RemoveIcon class="add-remove-icon" />
                    </AntPopconfirm>
                  </AntTooltip>
                </span>
              </span>
            </template>
          </AntTree>
        </div>
      </template>
    </AntAlert>

    <div v-if="isDev">docSectionsData: {{ docSectionsData.length }} 不包含 ReleaseVer</div>
    <div v-if="isDev">docSectionIds: {{ docSectionIds.length }} {{ docSectionIds }}</div>
  </div>
</template>

<script>
import {
  inject,
  computed,
  ref,
  reactive,
  watch,
  nextTick,
} from 'vue'

import { useRouter } from 'vue-router'

import {
  Row as AntRow,
  Col as AntCol,
  Form as AntForm,
  Input as AntInput,
  Alert as AntAlert,
  Select as AntSelect,
  Popover as AntPopover,
  Tooltip as AntTooltip,
  Popconfirm as AntPopconfirm,
  Tree as AntTree,
  Switch as AntSwitch,
  Table as AntTable,
  Button as AntButton,
  Drawer as AntDrawer,
} from 'ant-design-vue'

import QuestionIcon from '@ant-design/icons-vue/lib/icons/QuestionCircleOutlined'
import AddIcon from '@ant-design/icons-vue/lib/icons/PlusOutlined'
import RemoveIcon from '@ant-design/icons-vue/lib/icons/MinusOutlined'
import EditIcon from '@ant-design/icons-vue/lib/icons/EditOutlined'
import DeleteIcon from '@ant-design/icons-vue/lib/icons/DeleteOutlined'
import SaveIcon from '@ant-design/icons-vue/lib/icons/CheckOutlined'
import CancelIcon from '@ant-design/icons-vue/lib/icons/CloseOutlined'

import PlatformDocSelect from '@/components/ApiDoc/shared/PlatformDocSelect.vue'
import SectionPlatformTags from '@/components/ApiDoc/doc/SectionPlatformTags.vue'

import { APPENDIX_SECTION_TAGS_WITH_PLATFORM, isRootParentSectionId } from '../lib/constants'

import {
  getDocTitle,
  shouldDisplay,
  transformToNested,
  getLinkSectionIdMap,
} from '../lib/libsV3'

const getSectionPlatformMismatchHint = (section = {}, docData = {}) => {
  if (shouldDisplay({ ...section, docs: null }, docData)) return ''

  const hasPlatforms = !!section.platforms?.length
  const hasExcludedPlatforms = !!section.excludedPlatforms?.length
  const docPlatforms = docData.platforms || []
  const docExcludedPlatforms = docData.excludedPlatforms || []

  // 子本以 platforms 白名單定義可見範圍；區塊限定平台與白名單無交集（reason 333）
  if (hasPlatforms && docPlatforms.length) {
    return '區塊限定平台與子本平台白名單無交集'
  }
  // 區塊僅排除平台；子本白名單中至少一項落在區塊排除清單（reason 444）
  if (hasExcludedPlatforms && !hasPlatforms && docPlatforms.length) {
    return '區塊排除清單含有子本平台白名單中的平台'
  }
  // 區塊僅排除平台；子本排除清單每一項都在區塊排除清單內（reason 444）
  if (hasExcludedPlatforms && !hasPlatforms && docExcludedPlatforms.length) {
    return '區塊排除清單已涵蓋子本全部排除平台'
  }
  // 子本僅以 excludedPlatforms 定義可見範圍；區塊限定平台皆在子本排除清單內（reason 555）
  if (hasPlatforms && !docPlatforms.length && docExcludedPlatforms.length) {
    return '區塊限定平台皆在子本排除清單內'
  }
  return '區塊平台設定與目前子本不相容'
}

/** { ip, remark? }[] → 帶 key 的列（僅供表格） */
const toAllowedIpRows = (list) => {
  if (!Array.isArray(list)) return []
  return list.map((item, index) => ({
    key: item.key || `ip-${index}`,
    ip: item.ip || '',
    remark: item.remark || '',
  }))
}

const toAllowedIpPayload = rows => (
  (rows || [])
    .map(({ ip, remark }) => {
      const entry = { ip: String(ip || '').trim() }
      const remarkText = String(remark || '').trim()
      if (remarkText) entry.remark = remarkText
      return entry
    })
    .filter(({ ip }) => !!ip)
)

const isValidIpFormat = (ip) => {
  const normalized = String(ip || '').trim()
  if (!normalized) return false

  const IPV4_REGEX = /^(?:(?:25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)\.){3}(?:25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)$/
  return IPV4_REGEX.test(normalized)
}

export default {
  name: 'EditDoc',
  components: {
    AntRow,
    AntCol,
    AntInput,
    AntAlert,
    AntSelect,
    AntPopover,
    AntPopconfirm,
    AntFormItem: AntForm.Item,
    AntSwitch,
    AntTable,
    AntButton,
    AntDrawer,
    AntTextarea: AntInput.TextArea,
    PlatformDocSelect,
    SectionPlatformTags,
    AntTooltip,
    AntTree,
    QuestionIcon,
    AddIcon,
    RemoveIcon,
    EditIcon,
    DeleteIcon,
    SaveIcon,
    CancelIcon,
  },
  props: {
    selectedSectionState: Object,
    sectionsBySectionId: Object,
    fieldsBySectionId: Object,
    masterSectionsData: Array,
    docSectionsData: Array,
    validateInfos: Object,
    templateOptions: Array,
    platformOptions: Array,
    entirePlatformOptions: Array,
    onChange: Function,
    /** (allowedIPs) => Promise<boolean> — 直接 updateDoc，不走發布 */
    updateAllowedIPs: Function,
  },
  emits: ['change', 'addDocToSection', 'removeDocFromSection'],
  setup(props, { emit }) {
    const isDev = inject('isDev')
    const router = useRouter()

    const docTitle = computed(() => getDocTitle(props.selectedSectionState, { [props.selectedSectionState.templateId]: props.selectedSectionState }))

    const docSectionIds = computed(() => props.docSectionsData.map(s => s.sectionId))

    // 加入 docs: null 是因為 shouldDisplay 內會判斷 if (!docData.docId.includes('master') && docs?.length && !docs.includes(docData.docId)) display = false
    const shouldBeAddedSectionIds = computed(() => new Set(
      props.masterSectionsData
        .filter(s => shouldDisplay({ ...s, docs: null }, props.selectedSectionState)
          && !docSectionIds.value.includes(s.sectionId))
        .map(s => s.sectionId),
    ))

    const shouldBeAddedSections = computed(() => props.masterSectionsData
      .filter(s => shouldBeAddedSectionIds.value.has(s.sectionId)))

    const buildSuggestTreeData = (targetSectionIds) => {
      const displayIds = new Set(targetSectionIds)
      const sectionsById = Object.fromEntries(
        props.masterSectionsData.map(s => [s.sectionId, s]),
      )

      for (const sectionId of targetSectionIds) {
        let cur = sectionsById[sectionId]
        while (cur && !isRootParentSectionId(cur.parentSectionId)) {
          displayIds.add(cur.parentSectionId)
          cur = sectionsById[cur.parentSectionId]
        }
      }

      const data = props.masterSectionsData
        .filter(s => displayIds.has(s.sectionId))
        .map((s) => {
          const isActionable = targetSectionIds.has(s.sectionId)

          if (APPENDIX_SECTION_TAGS_WITH_PLATFORM.includes(s.tag)) {
            s.platformsFromDataTable = true
            s.platforms = Object.values(props.fieldsBySectionId[s.sectionId]?.row || {}).reduce((acc, row) => {
              // 8.15. Platforms Regional IP Restriction 會有 {{brand}}
              if (row.platform && row.platform !== '{{brand}}' && !acc.includes(row.platform)) acc.push(row.platform)
              return acc
            }, []).sort()
          }

          return {
            ...s,
            isLinkable: isActionable,
            isRemovable: isActionable,
            ...(!isActionable ? { class: 'section-suggest-tree-node--added' } : {}),
          }
        })

      return transformToNested({ data, useSortOrderForNumbering: true })
    }

    /** 樹狀顯示建議加入的 section；已在此子本的父節點仍顯示但不可點連結 */
    const shouldBeAddedTreeData = computed(() => buildSuggestTreeData(shouldBeAddedSectionIds.value))

    const shouldBeRemovedSectionIds = computed(() => new Set(
      props.masterSectionsData
        .filter((s) => {
          if (!docSectionIds.value.includes(s.sectionId)) return false
          if (!shouldDisplay({ ...s, docs: null }, props.selectedSectionState)) return true

          const { tag, sectionId } = s
          if (!APPENDIX_SECTION_TAGS_WITH_PLATFORM.includes(tag)) return false
          const rowData = Object.values(props.fieldsBySectionId[sectionId]?.row || {})
          return rowData.every(row => !shouldDisplay(row, props.selectedSectionState))
        })
        .map(s => s.sectionId),
    ))

    const shouldBeRemovedSections = computed(() => props.masterSectionsData
      .filter(s => shouldBeRemovedSectionIds.value.has(s.sectionId)))

    /** 樹狀顯示建議移除此子本的 section；父節點僅供結構參考 */
    const shouldBeRemovedTreeData = computed(() => buildSuggestTreeData(shouldBeRemovedSectionIds.value))

    const shouldBeAddedLinkSections = computed(() => {
      console.log('[EditDoc] computed shouldBeAddedLinkSections fieldsBySectionId', { fieldsBySectionId: props.fieldsBySectionId, docSectionIds: docSectionIds.value })
      const { docId } = props.selectedSectionState

      const fieldsData = []
      for (const sectionId of docSectionIds.value) {
        const scopes = props.fieldsBySectionId[sectionId]
        if (!scopes) continue
        for (const scope of Object.values(scopes)) {
          for (const f of Object.values(scope)) {
            const field = {
              ...f,
              ...(f.customizedVersion?.[docId] || {}),
            }
            if (shouldDisplay(field, props.selectedSectionState)) fieldsData.push(field)
          }
        }
      }

      const linkSectionIdMap = getLinkSectionIdMap(props.docSectionsData, fieldsData)

      const result = Object.entries(linkSectionIdMap).reduce((acc, [linkSectionId, linkUsedSectionIdsSet]) => {
        if (!docSectionIds.value.includes(linkSectionId)) {
          acc.push({
            ...props.sectionsBySectionId[linkSectionId],
            linkUsedSections: [...linkUsedSectionIdsSet].map(sectionId => props.sectionsBySectionId[sectionId] || {}),
          })
        }
        return acc
      }, [])

      console.log('[EditDoc] computed shouldBeAddedLinkSections', result)
      return result
    })

    const shouldBeAddedLinkSectionIds = computed(() => new Set(
      shouldBeAddedLinkSections.value.map(s => s.sectionId),
    ))

    const shouldBeAddedLinkTreeData = computed(() => {
      const linkMetaBySectionId = Object.fromEntries(
        shouldBeAddedLinkSections.value.map(s => [s.sectionId, s]),
      )
      const tree = buildSuggestTreeData(shouldBeAddedLinkSectionIds.value)
      const attachLinkMeta = nodes => nodes.map((node) => {
        const meta = linkMetaBySectionId[node.sectionId]
        const treeChildren = node.treeChildren?.length
          ? attachLinkMeta(node.treeChildren)
          : undefined
        return {
          ...node,
          ...(meta?.linkUsedSections && { linkUsedSections: meta.linkUsedSections }),
          ...(treeChildren && { treeChildren }),
        }
      })
      return attachLinkMeta(tree)
    })

    const treeData = computed(() => transformToNested({
      data: props.docSectionsData.map(s => ({ ...s, docId: props.selectedSectionState.docId })),
    }))

    const entirePlatformsMap = computed(() => Object.fromEntries(props.entirePlatformOptions.map(p => [p.value, p.label])))

    const ipDrawerVisible = ref(false)
    const ipWhiteListEnabled = computed(() => Array.isArray(props.selectedSectionState.allowedIPs))
    /** 關閉白名單時暫存，再開啟時還原寫入 DB */
    const cachedAllowedIPs = ref(null)

    const ipDataSource = ref([])
    const editableIpData = reactive({})
    const ipUpdating = ref(false)

    /** 已啟用白名單且無有效 IP（DB []）→ 拒絕所有 IP */
    const isIpWhiteListEmpty = computed(() => {
      const list = props.selectedSectionState.allowedIPs
      if (!Array.isArray(list)) return false
      return !list.some(item => String(item?.ip || '').trim())
    })

    const clearEditableIpData = () => {
      Object.keys(editableIpData).forEach(key => delete editableIpData[key])
    }

    const forceSyncIpDataSourceFromProps = () => {
      clearEditableIpData()
      const list = props.selectedSectionState.allowedIPs
      ipDataSource.value = Array.isArray(list) ? toAllowedIpRows(list) : []
    }

    const syncIpDataSourceFromProps = (list) => {
      if (!Array.isArray(list)) {
        ipDataSource.value = []
        clearEditableIpData()
        return
      }
      // 編輯中或尚有未存檔新增列時，勿被 props 覆寫
      if (Object.keys(editableIpData).length) return
      if (ipDataSource.value.some(row => row.isNew)) return
      ipDataSource.value = toAllowedIpRows(list)
    }

    watch(
      () => props.selectedSectionState.allowedIPs,
      list => syncIpDataSourceFromProps(list),
      { immediate: true, deep: true },
    )

    const ipWhiteListColumns = [
      {

        title: 'IP',
        dataIndex: 'ip',
        key: 'ip',
        width: '40%',
      },
      {
        title: 'Remark',
        dataIndex: 'remark',
        key: 'remark',
      },
      {
        title: 'Action',
        dataIndex: 'action',
        key: 'action',
        width: 90,
      },
    ]

    const onIpWhiteListSwitch = async (checked) => {
      if (ipUpdating.value) return
      ipUpdating.value = true
      try {
        if (checked) {
          const restored = Array.isArray(cachedAllowedIPs.value)
            ? toAllowedIpPayload(cachedAllowedIPs.value)
            : []
          const ok = await props.updateAllowedIPs(restored)
          if (ok) {
            clearEditableIpData()
            ipDrawerVisible.value = true
          }
          return
        }

        const current = props.selectedSectionState.allowedIPs
        const snapshot = Array.isArray(current)
          ? toAllowedIpRows(current).map(({ ip, remark }) => ({
            ip: String(ip || ''),
            remark: String(remark || ''),
          }))
          : []
        const ok = await props.updateAllowedIPs(null)
        if (ok) {
          cachedAllowedIPs.value = snapshot
          clearEditableIpData()
          ipDrawerVisible.value = false
        }
      } finally {
        ipUpdating.value = false
      }
    }

    const onAddAllowedIpRow = () => {
      const newData = {
        key: `${Date.now()}`,
        ip: '',
        remark: '',
        isNew: true,
      }
      editableIpData[newData.key] = newData
      ipDataSource.value = [editableIpData[newData.key], ...ipDataSource.value]

      nextTick(() => {
        const input = document.querySelector('.ip-whitelist-table .ant-table-tbody tr:first-child input')
        if (input) input.focus()
      })
    }

    const isDuplicateAllowedIp = (key, ip) => {
      const normalized = String(ip || '').trim()
      if (!normalized) return false
      return ipDataSource.value.some((row) => {
        if (row.key === key) return false
        const otherIp = editableIpData[row.key]
          ? String(editableIpData[row.key].ip || '').trim()
          : String(row.ip || '').trim()
        return otherIp === normalized
      })
    }

    const getAllowedIpError = (key, ip) => {
      const normalized = String(ip || '').trim()
      if (!normalized) return ''
      if (!isValidIpFormat(normalized)) return 'IP 格式不正確'
      if (isDuplicateAllowedIp(key, normalized)) return '此 IP 已存在'
      return ''
    }

    const onEditAllowedIpRow = (editKey) => {
      const data = ipDataSource.value.find(d => d.key === editKey)
      if (!data) return
      editableIpData[editKey] = {
        ip: data.ip || '',
        remark: data.remark || '',
      }
    }

    const onSaveAllowedIpRow = async (record) => {
      const { key } = record
      const draft = editableIpData[key]
      if (!draft?.ip?.trim()) return
      if (getAllowedIpError(key, draft.ip)) return
      if (ipUpdating.value) return

      const findData = ipDataSource.value.find(d => d.key === key)
      if (!findData) return

      Object.assign(findData, {
        ip: String(draft.ip || '').trim(),
        remark: String(draft.remark || ''),
      })
      delete findData.isNew
      delete editableIpData[key]

      ipUpdating.value = true
      try {
        const ok = await props.updateAllowedIPs(toAllowedIpPayload(
          ipDataSource.value.filter(row => !row.isNew),
        ))
        if (!ok) forceSyncIpDataSourceFromProps()
      } finally {
        ipUpdating.value = false
      }
    }

    const onCancelAllowedIpRow = (record) => {
      const { key } = record
      if (record.isNew) {
        ipDataSource.value = ipDataSource.value.filter(d => d.key !== key)
      }
      delete editableIpData[key]
    }

    const onDeleteAllowedIpRow = async (record) => {
      if (ipUpdating.value) return
      const prevRows = ipDataSource.value
      const nextRows = prevRows.filter(d => d.key !== record.key)
      ipDataSource.value = nextRows
      delete editableIpData[record.key]

      ipUpdating.value = true
      try {
        const ok = await props.updateAllowedIPs(toAllowedIpPayload(nextRows.filter(row => !row.isNew)))
        if (!ok) {
          ipDataSource.value = prevRows
          forceSyncIpDataSourceFromProps()
        }
      } finally {
        ipUpdating.value = false
      }
    }

    const onPlatformDocSelectChange = (key, val) => {
      console.log('EditDoc onPlatformDocSelectChange', key, val)
      emit('change', key, val)

      // Platforms 從 ALL 變成有選擇時，已存在的 ExcludedPlatforms 需清空
      if (props.selectedSectionState.excludedPlatforms && !props.selectedSectionState.excludedPlatforms.length && key === 'platforms' && val?.length) {
        emit('change', 'excludedPlatforms', null)
      }
    }

    const onTreeTitleClick = (sectionId) => {
      router.push(`/api-doc/editor/${props.selectedSectionState.wallet}/${sectionId}`)
    }

    const onAddDocToSection = (sectionId) => {
      if (!sectionId) return
      emit('addDocToSection', sectionId)
    }

    const onRemoveDocFromSection = (sectionId) => {
      if (!sectionId) return
      emit('removeDocFromSection', sectionId)
    }

    const sectionPlatformMismatchHint = section => (
      section ? getSectionPlatformMismatchHint(section, props.selectedSectionState) : ''
    )

    return {
      isDev,
      emit,
      docTitle,
      treeData,
      shouldBeAddedSections,
      shouldBeAddedTreeData,
      shouldBeRemovedSections,
      shouldBeRemovedTreeData,
      shouldBeAddedLinkSections,
      shouldBeAddedLinkTreeData,
      entirePlatformsMap,
      docSectionIds,
      ipWhiteListEnabled,
      isIpWhiteListEmpty,
      ipDrawerVisible,
      ipUpdating,
      ipDataSource,
      editableIpData,
      ipWhiteListColumns,
      onIpWhiteListSwitch,
      onAddAllowedIpRow,
      getAllowedIpError,
      onEditAllowedIpRow,
      onSaveAllowedIpRow,
      onCancelAllowedIpRow,
      onDeleteAllowedIpRow,
      onPlatformDocSelectChange,
      onTreeTitleClick,
      onAddDocToSection,
      onRemoveDocFromSection,
      sectionPlatformMismatchHint,
    }
  },
}
</script>
<style scoped>
:deep(.link) {
  cursor: pointer;
  transition: all 0.3s ease;
}

:deep(.link:hover) {
  color: #1890ff;
}

.section-alert {
  max-height: 400px;
  overflow-y: auto;
  align-items: flex-start;
  margin-bottom: 24px;
}

:deep(.section-alert .ant-alert-icon) {
  align-self: flex-start;
  margin-top: 3px;
}

.section-list {
  margin-top: 6px;
  margin-bottom: 0;
  padding: 0 0 0 20px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.section-suggest-tree {
  margin-top: 8px;
  max-height: 280px;
  overflow-y: auto;
}

:deep(.section-suggest-tree .ant-tree) {
  background: transparent;
}

:deep(.section-suggest-tree .ant-tree-title) {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 2px;
  cursor: default;
  user-select: text;
}

:deep(.section-suggest-tree-title) {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
}

:deep(.section-suggest-tree-title--added) {
  color: rgba(0, 0, 0, 0.45);
}

:deep(.section-suggest-tree .section-suggest-tree-node--added .ant-tree-switcher),
:deep(.section-suggest-tree .section-suggest-tree-node--added .ant-tree-node-content-wrapper),
:deep(.section-suggest-tree .section-suggest-tree-node--added .ant-tree-title) {
  cursor: not-allowed !important;
}

:deep(.section-suggest-action) {
  display: inline-flex;
  align-items: center;
  margin-left: 4px;
  cursor: pointer;
}

:deep(.add-remove-icon) {
  background-color: #ff5500;
  color: #fff;
  border-radius: 100%;
  padding: 2px;
  transition: all 0.3s ease;
}

:deep(.section-suggest-action:hover .add-remove-icon) {
  opacity: 0.8;
}

:deep(.hint-icon) {
  color: #1890ff;
  font-size: 14px;
  margin-left: 2px;
  cursor: pointer;
}

.form-item-label {
  display: flex;
  align-items: center;
  gap: 4px;
}

:deep(.question-icon) {
  color: #1890ff;
}

.ip-whitelist-switch-row {
  display: flex;
  align-items: center;
  gap: 4px;
}

.ip-whitelist-toolbar {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 16px;
}

.ip-whitelist-table .action-icons .anticon {
  cursor: pointer;
  margin: 0 6px;
  font-size: 16px;
}

.ip-whitelist-table .action-icons .anticon:hover {
  color: #1890ff;
}

.ip-whitelist-table .action-icons .action-icon--disabled {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}

.ip-whitelist-table .action-icons .action-icon--disabled .anticon,
.ip-whitelist-table .action-icons .action-icon--disabled:hover,
.ip-whitelist-table .action-icons .action-icon--disabled:hover .anticon {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}

.ip-whitelist-table :deep(.ip-input--error.ant-input),
.ip-whitelist-table :deep(.ip-input--error .ant-input) {
  border-color: #ff4d4f;
}

.ip-whitelist-table :deep(.ip-input--error.ant-input:focus),
.ip-whitelist-table :deep(.ip-input--error .ant-input:focus),
.ip-whitelist-table :deep(.ip-input--error.ant-input-affix-wrapper),
.ip-whitelist-table :deep(.ip-input--error.ant-input-affix-wrapper:hover),
.ip-whitelist-table :deep(.ip-input--error.ant-input-affix-wrapper-focused) {
  border-color: #ff4d4f;
  box-shadow: 0 0 0 2px rgba(255, 77, 79, 0.2);
}

.ip-field-error {
  margin-top: 4px;
  color: #ff4d4f;
  font-size: 12px;
  line-height: 1.4;
}
</style>
